import * as React from 'react'
import { Button } from 'antd'
import { usePBLPermission } from '../redux'

type Props = React.ComponentProps<typeof Button>

export default (p: Props) => {
  const permission = usePBLPermission()

  return <Button {...p} disabled={p.disabled || permission !== 'CONTRIBUTOR'} />
}
